<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="fmh">C<span class="epub-sc">ONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-bot"><a href="#/xhtml/epigraph#epig">Epigraph</a></p>
<p class="toc"><a href="#/xhtml/prologue#prol">Prologue</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Chapter 1</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Chapter 2</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">Chapter 3</a></p>
<p class="toc"><a href="#/xhtml/chapter4#ch4">Chapter 4</a></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="toc"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="toc"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="toc"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Chapter 24</span></p>
<p class="toc"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Chapter 25</span></p>
<p class="toc"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Chapter 26</span></p>
<p class="toc"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">Chapter 27</span></p>
<p class="toc"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">Chapter 28</span></p>
<p class="toc"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">Chapter 29</span></p>
<p class="toc"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample">Chapter 30</span></p>
<p class="toc"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample">Chapter 31</span></p>
<p class="toc"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample">Chapter 32</span></p>
<p class="toc"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample">Chapter 33</span></p>
<p class="toc"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample">Chapter 34</span></p>
<p class="toc"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample">Chapter 35</span></p>
<p class="toc"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample">Chapter 36</span></p>
<p class="toc"><span href="#/xhtml/chapter37#ch37" title="Link target outside of Sample">Chapter 37</span></p>
<p class="toc"><span href="#/xhtml/chapter38#ch38" title="Link target outside of Sample">Chapter 38</span></p>
<p class="toc"><span href="#/xhtml/chapter39#ch39" title="Link target outside of Sample">Chapter 39</span></p>
<p class="toc"><span href="#/xhtml/chapter40#ch40" title="Link target outside of Sample">Chapter 40</span></p>
<p class="toc"><span href="#/xhtml/chapter41#ch41" title="Link target outside of Sample">Chapter 41</span></p>
<p class="toc"><span href="#/xhtml/chapter42#ch42" title="Link target outside of Sample">Chapter 42</span></p>
<p class="toc"><span href="#/xhtml/chapter43#ch43" title="Link target outside of Sample">Chapter 43</span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#epil" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/teaser#teaser" title="Link target outside of Sample"><span class="epub-i">Book of Judas</span> Excerpt</span></p>
<p class="toc"><span href="#/xhtml/facts#bm1" title="Link target outside of Sample">Hard to Fathom Facts</span></p>
<p class="toc"><span href="#/xhtml/references#bm2" title="Link target outside of Sample">References and Recommended Reading</span></p>
<p class="toc"><span href="#/xhtml/aboutauthor#about" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/Copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f4943ea4